import { Input, Space, Switch, Table } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { IntegrationExecution } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';

export function ExecutionRecordsPage(props: { integrationExecution?: IntegrationExecution }) {
  const [loading, setLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState<any[]>();
  const [records, setRecords] = useState<any[]>();

  const [tableCurrent, setTableCurrent] = useState(1);
  const [tablePageSize, setTablePageSize] = useState(10);
  const [tableTotal, setTableTotal] = useState(0);

  const [showFailed, setShowFailed] = useState(false);
  const [search, setSearch] = useState<string>();

  const loadRecords = useCallback(() => {
    setLoading(true);
    let offset = (tableCurrent - 1) * tablePageSize;
    const queryParams = [`limit=${tablePageSize}`, `offset=${offset}`];
    if (search) {
      queryParams.push(`search=${search}`);
    }
    if (showFailed) {
      queryParams.push('success=false');
    }
    const queryParamsStr = queryParams.join('&');
    apiClient
      .get(
        `integrations/${props.integrationExecution?.integrationId}/executions/${props.integrationExecution?.id}/records?${queryParamsStr}`,
      )
      .then(response => {
        const responseData = response.data.records as any[];

        if (!responseData || !responseData.length) {
          setRecords(undefined);
          setTableTotal(0);
          setTableColumns(undefined);
          return;
        }

        setRecords(responseData);
        setTableTotal(response.data.count);

        const columns = Object.keys(responseData[0]).map(k => {
          return {
            title: k === 'resultFeedback' ? 'Aktarılan kayıt durumu' : k,
            dataIndex: k,
            key: k,
            render: (value: any) => value?.toString(),
          };
        });
        setTableColumns(columns);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.integrationExecution?.id, props.integrationExecution?.integrationId, search, showFailed, tableCurrent, tablePageSize]);

  useEffect(() => {
    loadRecords();
  }, [loadRecords]);

  const onShowFailedChange = (value: boolean) => {
    setTableCurrent(1);
    setShowFailed(value);
  };

  const onTableChange = (pagination: any) => {
    setTableCurrent(pagination.current);
    setTablePageSize(pagination.pageSize);
  };

  const onSearch = (input: string) => {
    input = input.trim();
    setSearch(input === '' ? undefined : input);
  };

  return (
    <>
      {props.integrationExecution?.integration?.integrationType === 'EXPORT' && (
        <div style={{ textAlign: 'right', marginBottom: '1rem' }}>
          <Space size={32}>
            <Input.Search placeholder="Arama" allowClear={true} onSearch={onSearch} style={{ width: 200 }} />
            <Space>
              <Switch checked={showFailed} onChange={onShowFailedChange} />
              <span>Aktarılamayan kayıtları göster</span>
            </Space>
          </Space>
        </div>
      )}
      <Table
        columns={tableColumns}
        dataSource={records}
        loading={loading}
        scroll={{ x: '100%' }}
        pagination={
          search
            ? false
            : {
                current: tableCurrent,
                total: tableTotal,
                pageSize: tablePageSize,
                pageSizeOptions: ['10', '25', '50', '100'],
                position: ['bottomCenter'],
                showTotal: (total, range) => `Toplam ${total} kayıt. ${range[0]}-${range[1]} arası gösteriliyor.`,
                showSizeChanger: true,
              }
        }
        onChange={onTableChange}
      />
    </>
  );
}
